import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CustomerGateway } from '@cigna/cigna-for-brokers/shared/gateways';
import { UserAgreementResponse } from './login.models';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(private _http: HttpClient, private _gw: CustomerGateway) {}

  linkUser(id: string) {
    return this._http.post<void>(this._gw.linkUserUrl(id), null);
  }

  getUserAgreementStatus() {
    return this._http.get<UserAgreementResponse>(this._gw.userAgreementUrl());
  }

  acceptNewUserAgreement(version: string) {
    return this._http.post<void>(this._gw.userAgreementUrl(), {
      usrAgrmntVs: version,
    });
  }
}
